var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../base/contentbase.service';
import { ColumnService } from '../../items/columns/column/column.service';
var ModalComponent = /** @class */ (function (_super) {
    __extends(ModalComponent, _super);
    function ModalComponent(router, route, logger, action, message, page, service, columnService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.columnService = columnService;
        _this.buttons = [];
        _this.targetComponents = [];
        return _this;
    }
    ModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setButtons(this.component);
        this.modalSubscription = this.action.modalObservable.subscribe(function (params) {
            if (params.event === 'open') {
                if (_this.componentName) {
                    for (var _i = 0, _a = params.targets; _i < _a.length; _i++) {
                        var tar = _a[_i];
                        var re = new RegExp('^' + tar + '$');
                        if (_this.componentName.match(re)) {
                            _this.openRemodal();
                            break;
                        }
                    }
                }
            }
            else if (params.event === 'close') {
                _this.closeRemodal();
            }
        });
    };
    ModalComponent.prototype.ngAfterViewInit = function () {
        this.modal = this.remodalElement.nativeElement;
    };
    ModalComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.refSubscription.unsubscribe();
        this.modeSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ModalComponent.prototype.onEvent = function (e1, e2, rec) {
        this.action.firstAction(e2, { buttonType: e1 });
    };
    ModalComponent.prototype.openRemodal = function () {
        this.targetComponents = [];
        this.resetComponent(this.component.components);
        this.columnService.setInit(this.targetComponents);
        this.columnService.addError(this.targetComponents, true);
        this.remodal = $(this.modal).remodal({ hashTracking: false, closeOnEscape: false, closeOnOutsideClick: false });
        this.remodal.open();
    };
    ModalComponent.prototype.closeRemodal = function () {
        if ($(this.modal).hasClass('remodal-is-opened')) {
            this.remodal.close();
        }
    };
    ModalComponent.prototype.setChangeCompData = function (component) {
        this.setButtons(component);
    };
    ModalComponent.prototype.setButtons = function (component) {
        var _this = this;
        var buttons = (component.params && component.params.buttons ? component.params.buttons : []);
        this.buttons = buttons.filter(function (x) { return _this.action.validEvent(x.event); });
    };
    ModalComponent.prototype.resetComponent = function (components) {
        for (var _i = 0, components_1 = components; _i < components_1.length; _i++) {
            var comp = components_1[_i];
            if (comp.component === 'TabGroupComponent') {
                this.action.action('', comp.name + 'TabReset');
            }
            if (comp.component === 'ToggleComponent') {
                this.action.action('', comp.name + 'ToggleReset');
            }
            this.targetComponents.push(comp.name);
            this.resetComponent(comp.components || []);
        }
    };
    ModalComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.modalSubscription.unsubscribe();
        if ($(this.modal).parent().hasClass('remodal-wrapper')) {
            this.remodal.destroy();
        }
    };
    ModalComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'modal',
                    template: "<!-- remodal -->\n<div class=\"remodal\" id=\"{{ componentName }}\" #remodal>\n  <div class=\"remodal_whitebg -p-0\">\n    <alertblock [modal]=\"true\"></alertblock>\n    <ng-template ngFor let-comp [ngForOf]=\"component.components\">\n      <content [component]=\"comp\"></content>\n    </ng-template>\n  </div>\n  <div class=\"remodal_btns\">\n    <ul [key]=\"'remodalBtn'\" buttonDir>\n      <li *ngFor=\"let button of buttons\" [key]=\"'remodalBtn'\" [btn]=\"button\" buttonDir>\n        <item-btn [key]=\"'remodalBtn'\" [btn]=\"button\" (clickBtn)=\"onEvent(button.type, $event)\"></item-btn>\n      </li>\n    </ul>\n  </div>\n</div>\n<!-- /remodal -->\n"
                }] }
    ];
    /** @nocollapse */
    ModalComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService },
        { type: ColumnService }
    ]; };
    ModalComponent.propDecorators = {
        remodalElement: [{ type: ViewChild, args: ['remodal',] }]
    };
    return ModalComponent;
}(ContentBaseComponent));
export { ModalComponent };
//# sourceMappingURL=modal.component.js.map